import type { SvgComponent } from '@/types/SvgComponent';

export const YarnIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M12 21.0001L21.75 20.9973"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.65283 20.3569C9.30617 17.4842 10.7155 14.8383 12.7348 12.6932C14.7541 10.5481 17.3101 8.98175 20.1381 8.15625"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.37598 18.0936C6.28689 15.1165 7.87042 12.3888 10.0041 10.1215C12.1377 7.85427 14.7643 6.10817 17.6807 5.01831"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.356 20.9934C12.8797 18.8463 13.9515 16.8717 15.4665 15.2625C16.9815 13.6533 18.888 12.4646 20.9997 11.8125"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.0293 11.2734C4.76005 11.3764 6.45124 11.8336 7.99805 12.6169"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.14258 7.60791C6.36007 7.85994 8.50283 8.56176 10.4398 9.67041"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.23047 4.36694C9.46477 4.93256 11.5855 5.87719 13.5005 7.15976"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
